import * as React from "react";
import { Form } from "semantic-ui-react";
import { CaseType, LinkObject } from "@teamprevent/common/model";

import { OrgStructureDetailModel } from "../orgStructure/models";

import { CustomerUserCaseTypeOrgStructures } from "./models";

import { CaseTypeOrgStructureEdit } from "./CaseTypeOrgStructureEdit";

interface Props {
    orgStructures: OrgStructureDetailModel[];
    caseTypeOrgStructures: CustomerUserCaseTypeOrgStructures[];
    onCaseTypeOrgStructuresChanged: (
        caseTypeOrgStructure: CustomerUserCaseTypeOrgStructures,
        orgStructures: LinkObject[],
        includeLinkedImmunisationCases?: boolean) => void;
}

const caseTypeOrder = [CaseType.REFERRAL, CaseType.PPQ, CaseType.PHYSIOTHERAPY_REFERRAL, CaseType.HEALTH_SURVEILLANCE];

export const CaseTypeOrgStructuresEdit: React.FunctionComponent<Props> = (props: Props) => (<>
    <Form.Field>
        <label>View all cases for</label>
    </Form.Field>

    {
        props.caseTypeOrgStructures
            ?.sort((a, b) => caseTypeOrder.indexOf(a.value) - caseTypeOrder.indexOf(b.value))
            .map(caseType => (<CaseTypeOrgStructureEdit
                key={caseType.value}
                caseTypeOrgStructure={caseType}
                orgStructures={props.orgStructures}
                onCaseTypeOrgStructuresChanged={props.onCaseTypeOrgStructuresChanged}
            />))
    }
</>);
